import React, { useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import LoginHeader from './loginHeader/loginHeader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoginContainer from 'pages/loginPage/components/loginContainer';
import { useTranslation } from 'react-i18next';
import { authApi } from 'app/api/authApi';
import { AxiosError } from 'axios';
import mobxStore from 'app/store/rootStore';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';
import LoginFooter from 'pages/loginPage/loginFooter/loginFooter';
import RecoverForm from 'pages/loginPage/forms/recoverForm';

export default observer(function RestorePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isCodeError, setIsCodeError] = useState(false);

  const codeRef = useRef(searchParams.get('code'));

  useEffect(() => {
    if (!codeRef.current) {
      navigate('/login');
    }

    const code = String(codeRef.current);
    setSearchParams({});

    const validate = async () => {
      try {
        await authApi.verifyRestoreLink({ code });
      } catch (err) {
        const axiosErr = err as AxiosError;

        if (axiosErr.response?.status === 400) {
          setIsCodeError(true);
          return;
        }

        mobxStore.notificationsStore.errorMessage = t(
          'notifications.errors.default'
        );
        console.error(err);
      }
    };

    validate();
  }, [navigate, t]);

  return (
    <LoginContainer>
      <LoginHeader
        isError={isCodeError}
        text={
          isCodeError
            ? t('noCategory.notValidLink')
            : t('login.makingNewPassword')
        }
      ></LoginHeader>
      {isCodeError ? (
        <>
          <Typography
            variant="f14"
            color="error.main"
            sx={{ textAlign: 'center', fontWeight: 300 }}
          >
            Вы&nbsp;использовали неактуальную ссылку для восстановления пароля.
            Вышлите ссылку на&nbsp;восстановление заново или войдите
            в&nbsp;систему
          </Typography>

          <PrimaryButton
            sx={{
              width: 1,
            }}
            form="signupForm"
            variant="contained"
            type="submit"
            onClick={() => {
              navigate('/login#restore');
            }}
          >
            <Typography variant="f20">Воссстановить пароль</Typography>
          </PrimaryButton>

          <LoginFooter
            activeForm="invite"
            handleSwitchForm={() => {
              navigate('/login');
            }}
          ></LoginFooter>
        </>
      ) : (
        <RecoverForm
          onSubmit={async (data) => {
            try {
              const email = await mobxStore.authStore.recover({
                ...data,
                code: codeRef.current || '',
              });

              await mobxStore.authStore.login({
                username: email,
                password: data.password,
              });
            } catch (e) {
              mobxStore.notificationsStore.errorMessage = t(
                'notifications.errors.default'
              );
              console.error(e);
            }
          }}
        ></RecoverForm>
      )}
    </LoginContainer>
  );
});
